import { mergeDeepRight } from 'ramda'
import { EventBus } from './index'

const TransformPayload = (value = {}) => {
  if (!(value instanceof Array)) return [value, {}]
  return value.length === 1 ? [...value, {}] : value
}

export default function (namespace) {
  let state = {
    item: {},
    items: [],
    filter: null,
    promises: {
      fetch: null,
      fetchOne: null,
      mutate: null,
      remove: null,
    },
    states: {
      fetch: false,
      fetchOne: false,
      mutate: false,
      remove: false,
    },
    errors: {
      fetch: null,
      fetchOne: null,
      mutate: null,
      remove: null,
    },
  }

  let mutations = {
    set(state, payload) {
      return (state[payload instanceof Array ? 'items' : 'item'] = payload || {})
    },
    setFilter(state, payload) {
      state.filter = payload
    },
    setPromise(state, { key, promise }) {
      key = key instanceof Array ? key : [key]
      key.forEach(k => {
        state.promises[k] = promise
        state.states[k] = true
        state.errors[k] = null

        promise.catch(err => {
          if (state.promises[k] === promise) state.errors[k] = err
        })
        promise.finally(() => (state.states[k] = false))
      })
      return promise
    },
  }

  let actions = {
    fetch(action) {
      return function ({ commit }, payloadRaw) {
        let [payload, options] = TransformPayload(payloadRaw)

        let isOne = Boolean('id' in payload)
        commit('set', isOne ? {} : [])
        let promise = action(payload, options)
        if (options.setPromise !== false) commit('setPromise', { key: isOne ? 'fetchOne' : 'fetch', promise })

        commit('setFilter', payload.filter)

        return promise.then(data => {
          commit('set', data)

          EventBus.$emit(`${namespace}:${isOne ? 'fetchOne' : 'fetch'}`, data)

          return data
        })
      }
    },
    mutate(action) {
      return function ({ commit, state }, payloadRaw) {
        let oldVal = state.item
        let [payload, options] = TransformPayload(payloadRaw)
        let promise = action(payload, options)
        if (options.setPromise !== false) commit('setPromise', { key: 'mutate', promise })

        return promise.then(data => {
          if (options.strategy === 'none') return data

          if (typeof options.strategy === 'function')
            data = options.strategy(state.item, mergeDeepRight(payload, data), data)
          else data = mergeDeepRight(state.item, mergeDeepRight(payload, data))

          commit('set', data)

          EventBus.$emit(`${namespace}:${payload.id ? 'update' : 'create'}`, data, oldVal)

          return data
        })
      }
    },
    remove(action) {
      return function ({ commit, state }, payloadRaw) {
        let [payload, options] = TransformPayload(payloadRaw)
        let promise = action(payload, options)
        if (options.setPromise !== false) commit('setPromise', { key: 'remove', promise })

        return promise
      }
    },
  }

  return { state, mutations, actions }
}
